import React, { useContext, useEffect, useState } from 'react'
import { KnowledgeSimilarModel } from '../../../model/knowledge.model'
import InputItem from './InputItem'
import './KSimilarQuestionSection.css'
import AddInputButton from './AddInputButton'
import { EditingKnowledgeDispatch } from '..'
interface KSimilarQuestionSectionProps {
    similars?: KnowledgeSimilarModel[]
    disabled?: boolean
}
const KSimilarQuestionSection: React.FC<KSimilarQuestionSectionProps> = (
    props
) => {
    const { similars = [], disabled } = props
    const { dispatch } = useContext(EditingKnowledgeDispatch)
    const [addable, setAddable] = useState(true)
    useEffect(() => {
        setAddable(
            similars.filter((item) => !item.k_question.trim()).length === 0
        )
    }, [similars])
    return (
        <div
            className='k-similar-question'
            onClick={(e) => e.stopPropagation()}
        >
            <div className='similar-list'>
                {similars.map((item, index) =>
                    !disabled ? (
                        <InputItem
                            className='similar-item'
                            placeholder='请输入相似问题'
                            deleteable={similars.length > 1}
                            key={item.kq_id || item.flag_id}
                            onChange={(value) =>
                                dispatch({
                                    type: 'updateKSimilar',
                                    payload: {
                                        index,
                                        value,
                                    },
                                })
                            }
                            autoFocus={item.k_question === ''}
                            onDelete={() =>
                                dispatch({
                                    type: 'deleteKSimilar',
                                    payload: index,
                                })
                            }
                            value={item.k_question}
                        />
                    ) : (
                        <p className='similar-item-disabled' key={item.kq_id}>
                            {item.k_question}
                        </p>
                    )
                )}
            </div>
            <AddInputButton
                className={`add-input-button ${!addable ? 'disable' : ''}`}
                disabled={!addable}
                onClick={() => {
                    dispatch({
                        type: 'addKSimilar',
                    })
                }}
            />
        </div>
    )
}

export default KSimilarQuestionSection
